import {
  getAll,
  getPage,
  getDetail,
  downloadFile,
  getFoldFileList,
  makeTask
} from '@/api/avfileuploadrequesttaskserv'

export default {
  state: {
    state_AvFileUploadRequestTask_GetAllResult: null,
    state_AvFileUploadRequestTask_GetPageResult: null,
    state_AvFileUploadRequestTask_GetDetailResult: null,
    state_AvFileUploadRequestTask_DownloadFileResult: null,
    state_AvFileUploadRequestTask_GetFoldFileListResult: null,
    state_AvFileUploadRequestTask_MakeTaskResult: null
  },
  mutations: {
    SET_AVFILEUPLOADREQUESTTASK_GETALL_RESULT: (state, rst) => {
      state.state_AvFileUploadRequestTask_GetAllResult = rst
    },
    SET_AVFILEUPLOADREQUESTTASK_GETPAGE_RESULT: (state, rst) => {
      state.state_AvFileUploadRequestTask_GetPageResult = rst
    },
    SET_AVFILEUPLOADREQUESTTASK_GETDETAIL_RESULT: (state, rst) => {
      state.state_AvFileUploadRequestTask_GetDetailResult = rst
    },
    SET_AVFILEUPLOADREQUESTTASK_DOWNLOADFILE_RESULT: (state, rst) => {
      state.state_AvFileUploadRequestTask_DownloadFileResult = rst
    },
    SET_AVFILEUPLOADREQUESTTASK_GETFOLDFILELIST_RESULT: (state, rst) => {
      state.state_AvFileUploadRequestTask_GetFoldFileListResult = rst
    },
    SET_AVFILEUPLOADREQUESTTASK_MAKETASK_RESULT: (state, rst) => {
      state.state_AvFileUploadRequestTask_MakeTaskResult = rst
    }
  },
  actions: {
    AvFileUploadRequestTaskServ_GetAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_AVFILEUPLOADREQUESTTASK_GETALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_AVFILEUPLOADREQUESTTASK_GETALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AvFileUploadRequestTaskServ_GetPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_AVFILEUPLOADREQUESTTASK_GETPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_AVFILEUPLOADREQUESTTASK_GETPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AvFileUploadRequestTaskServ_GetDetail ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_AVFILEUPLOADREQUESTTASK_GETDETAIL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_AVFILEUPLOADREQUESTTASK_GETDETAIL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AvFileUploadRequestTaskServ_DownloadFile ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        downloadFile(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_AVFILEUPLOADREQUESTTASK_DOWNLOADFILE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_AVFILEUPLOADREQUESTTASK_DOWNLOADFILE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AvFileUploadRequestTaskServ_GetFoldFileList ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getFoldFileList(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_AVFILEUPLOADREQUESTTASK_GETFOLDFILELIST_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_AVFILEUPLOADREQUESTTASK_GETFOLDFILELIST_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AvFileUploadRequestTaskServ_MakeTask ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        makeTask(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_AVFILEUPLOADREQUESTTASK_MAKETASK_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_AVFILEUPLOADREQUESTTASK_MAKETASK_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_AvFileUploadRequestTask_GetAllResult: state => {
      return state.state_AvFileUploadRequestTask_GetAllResult
    },
    get_AvFileUploadRequestTask_GetPageResult: state => {
      return state.state_AvFileUploadRequestTask_GetPageResult
    },
    get_AvFileUploadRequestTask_GetDetailResult: state => {
      return state.state_AvFileUploadRequestTask_GetDetailResult
    },
    get_AvFileUploadRequestTask_DownloadFileResult: state => {
      return state.state_AvFileUploadRequestTask_DownloadFileResult
    },
    get_AvFileUploadRequestTask_GetFoldFileListResult: state => {
      return state.state_AvFileUploadRequestTask_GetFoldFileListResult
    },
    get_AvFileUploadRequestTask_MakeTaskResult: state => {
      return state.state_AvFileUploadRequestTask_MakeTaskResult
    }
  }
}
